/* Items */
export const appListItems = [
  {
    id: 0,
    name: "Compress PDF",
    subtitle: "Reduce the size of your pdf without losing quality",
    navigate: "/compress_pdf",
    state: { title: "Compress PDF files" },
    online: false,
  },
  {
    id: 1,
    name: "PDF Converter",
    subtitle: "Convert Word, PowerPoint, Excel files to and from PDF",
    navigate: "/pdf_converter",
    state: { title: "PDF Converter Free" },
    online: true,
  },
  {
    id: 2,
    name: "PDF OCR",
    subtitle: "Make texts in pdf file scannable and searchable",
    navigate: "/pdf_ocr",
    state: { title: "PDF OCR - Searchable PDF Online" },
    online: true,
  },
  {
    id: 3,
    name: "PPT to PDF",
    subtitle:
      "Convert Power Point Presentations to pdf documents. ex: ppt to pdf, pptx to pdf",
    navigate: "/ppt_to_pdf",
    state: { title: "PPT To PDF Converter Online Free" },
    online: true,
  },
  {
    id: 4,
    name: "PDF to PPT",
    subtitle:
      "Convert pdf documents to editable Power Point Presentations. ex: pdf to ppt, pdf to pptx",
    navigate: "/pdf_to_ppt",
    state: { title: "PDF To PPT Converter Online Free" },
    online: true,
  },
  {
    id: 5,
    name: "JPG to PDF",
    subtitle: "Convert JPG, PNG, BMP, GIF, TIFF images to PDF documents",
    navigate: "/image_to_pdf",
    state: {
      title: "Image to PDF / JPG to PDF converter",
    },
    online: false,
  },
  {
    id: 6,
    name: "PDF to JPG",
    subtitle: "Convert PDF to JPG, PNG, BMP, GIF, TIFF image",
    navigate: "/pdf_to_image",
    state: {
      title:
        "PDF to JPG, PDF to PNG, PDF to SVG, PDF to WEBP, PDF to BMP converter",
    },
    online: false,
  },
  {
    id: 7,
    name: "Excel to PDF",
    subtitle:
      "Convert Excel spreadsheets to PDF documents. ex: xls to pdf, xlsx to pdf, csv to pdf",
    navigate: "/excel_to_pdf",
    state: {
      title: "Excel To PDF Converter Online Free",
    },
    online: true,
  },
  {
    id: 8,
    name: "PDF to Excel",
    subtitle:
      "Convert PDF documents to editable Excel spreadsheets. ex: pdf to xls, pdf to xlsx, pdf to csv",
    navigate: "/pdf_to_excel",
    state: {
      title: "PDF To Excel Converter Online Free",
    },
    online: true,
  },
  {
    id: 9,
    name: "Word to PDF",
    subtitle:
      "Convert Word documents to PDF files. ex: doc to pdf, docx to pdf",
    navigate: "/word_to_pdf",
    state: {
      title: "Word To PDF Converter Online Free",
    },
    online: true,
  },
  {
    id: 10,
    name: "PDF to Word",
    subtitle:
      "Convert PDF files to editable Word documents. ex: pdf to doc, pdf to docx",
    navigate: "/pdf_to_word",
    state: {
      title: "PDF To Word Converter Online Free",
    },
    online: true,
  },
  {
    id: 11,
    name: "Edit PDF",
    subtitle: "Add texts, shapes, images to PDF document",
    navigate: "/pdf_editor",
    state: {
      title: "PDF Editor Online / Offline For Free",
    },
    online: false,
  },
  {
    id: 12,
    name: "PDF Annotator",
    subtitle: "Write, draw, highlight on your PDF document",
    navigate: "/pdf_annotator",
    state: {
      title: "PDF Annotator Free",
    },
    online: false,
  },
  {
    id: 13,
    name: "PDF Reader",
    subtitle: "View, Print and Share PDF online",
    navigate: "/pdf_viewer",
    state: {
      title: "PDF Viewer & PDF Reader",
    },
    online: false,
  },
  {
    id: 14,
    name: "Crop PDF",
    subtitle: "Crop and trim your PDF documents",
    navigate: "/crop_pdf",
    state: {
      title: "Trim PDF & Crop PDF Files Free",
    },
    online: false,
  },
  {
    id: 15,
    name: "Watermark PDF",
    subtitle: "Add watermarks to your PDF document",
    navigate: "/watermark_pdf",
    state: {
      title: "Watermark PDF documents",
    },
    online: false,
  },
  {
    id: 16,
    name: "Number Pages",
    subtitle: "Insert page numbers in PDF document",
    navigate: "/number_pdf_pages",
    state: {
      title: "Add Page Numbers To PDF File Free",
    },
    online: false,
  },
  {
    id: 17,
    name: "Image Resizer",
    subtitle: "Resize & Compress images (under 100KB & 300KB)",
    navigate: "/image_resizer",
    state: {
      title: "Image Resizer & Image Compressor, Under 300KB Free",
    },
    online: false,
  },
  {
    id: 18,
    name: "Image Rotator",
    subtitle:
      "Batch rotate & flip images. Flip your image horizontally or vertically.",
    navigate: "/flip_image",
    state: {
      title: "Bulk Flip Images & Rotate Image Free",
    },
    online: false,
  },
  {
    id: 19,
    name: "Trim & Crop Image",
    subtitle: "Crop JPG, PNG or GIF by defining a rectangle in pixels.",
    navigate: "/crop_image",
    state: {
      title: "Crop Image & Trim Image Free",
    },
    online: false,
  },
  {
    id: 20,
    name: "Delete PDF Pages",
    subtitle: "Remove one or multiple pages from your PDF document",
    navigate: "/delete_pdf_pages",
    state: {
      title: "Delete PDF Pages Tool Free",
    },
    online: false,
  },
  {
    id: 21,
    name: "Extract PDF Pages",
    subtitle: "Extract selected pages from PDF document",
    navigate: "/extract_pdf_pages",
    state: {
      title: "Extract PDF Pages Free",
    },
    online: false,
  },
  {
    id: 22,
    name: "Rotate PDF",
    subtitle:
      "Rotate one or all pages of your PDF file. Rotate, flip, swap, delete pdf pages.",
    navigate: "/rotate_pdf",
    state: { title: "Rotate PDF Pages, Flip PDF Pages Free" },
    online: false,
  },
  {
    id: 23,
    name: "Merge PDF",
    subtitle: "Combine two or more PDFs in one unified document",
    navigate: "/merge_pdf",
    state: { title: "Merge PDF files" },
    online: false,
  },
  {
    id: 24,
    name: "Rearrange PDF",
    subtitle: "Rearrange pdf pages in document",
    navigate: "/rearrange_pdf",
    state: { title: "Reorder PDF Pages For Free" },
    online: false,
  },
  {
    id: 25,
    name: "Split PDF",
    subtitle: "Seperate PDF document in two or more files",
    navigate: "/split_pdf",
    state: { title: "Split PDF in parts" },
    online: false,
  },
  {
    id: 26,
    name: "Sign PDF",
    subtitle: "Digitally sign PDF document",
    navigate: "/",
    online: false,
  },
  {
    id: 27,
    name: "Unlock PDF",
    subtitle: "Remove password from PDF document",
    navigate: "/unlock_pdf",
    state: { title: "Remove Password From PDF Files" },
    online: false,
  },
  {
    id: 28,
    name: "Lock PDF",
    subtitle: "Protect and encrypt PDF files by adding password",
    navigate: "/lock_pdf",
    state: { title: "Password Protect PDF Documents, Lock PDF" },
    online: false,
  },
  {
    id: 29,
    name: "Flatten PDF",
    subtitle: "Make your PDF uneditable. Flatten all pdf layers and forms.",
    navigate: "/flatten_pdf",
    state: { title: "Flatten PDF For Free" },
    online: false,
  },
  {
    id: 30,
    name: "PDF Under 200KB",
    subtitle: "Reduce PDF size to under 200KB",
    navigate: "/compress_pdf_under_200_kb",
    state: { title: "Compress PDFs under 200 KB" },
    online: false,
  },
  {
    id: 31,
    name: "Resize PDF",
    subtitle: "Resize PDF documents to specific resolution",
    navigate: "/resize_pdf",
    state: { title: "Resize PDF Files" },
    online: false,
  },
  {
    id: 32,
    name: "Grayscale PDF",
    subtitle: "Make a PDF text and images black and white (Grayscale).",
    navigate: "/grayscale_pdf",
    state: { title: "PDF to Grayscale PDF Converter" },
    online: false,
  },
  {
    id: 33,
    name: "HTML to PDF",
    subtitle: "Convert .html files to printable PDF.",
    navigate: "/html_to_pdf",
    state: { title: "Convert HTML to PDF For Free" },
    online: true,
  },
  {
    id: 34,
    name: "PDF Metadata Editor",
    subtitle:
      "Edit PDF metadata (Author, Creator, Subject, Title, Keywords, Producer, Creation Date etc)",
    navigate: "/pdf_metadata_editor",
    state: { title: "Edit PDF Metadata Online" },
    online: false,
  },
  {
    id: 35,
    name: "N-up & PDF Imposition",
    subtitle:
      "Place multiple pages side by side to print. Select from predefined layouts.",
    navigate: "/pdf_n_up_tool",
    state: { title: "Print Multiple PDF Pages Per Sheet Per Paper" },
    online: false,
  },
  {
    id: 36,
    name: "Add Blank Pages To PDF",
    subtitle:
      "Add blank pages to pdf document. Insert new pages to pdf at specific location.",
    navigate: "/add_pages_pdf",
    state: { title: "Add Blank Pages To PDF File For Free" },
    online: false,
  },
  {
    id: 37,
    name: "PDF Scanner",
    subtitle: "Scan documents in pdf format.",
    navigate: "/document_scanner",
    state: { title: "PDF Scanner & Document Scanner Free" },
    online: false,
  },
  {
    id: 38,
    name: "QR Code Reader",
    subtitle: "Read all type of QR codes online for free.",
    navigate: "/qr_scanner",
    state: { title: "QR Code Scanner & Barcode Scanner Free" },
    online: false,
  },
  {
    id: 39,
    name: "QR Code Generator",
    subtitle: "Generate QR codes online for free.",
    navigate: "/qr_generator",
    state: { title: "Generate All Types Of QR Code & Barcodes" },
    online: false,
  },
  {
    id: 40,
    name: "Compress (.zip) Files",
    subtitle: "Create Zip file from your files online for free.",
    navigate: "/compress_files",
    state: { title: "Create Zip File, File Compressor" },
    online: false,
  },
  {
    id: 41,
    name: "Image Converter",
    subtitle:
      "Convert image file types (.jpg, .jpeg, .png, .webp, .svg etc), Resolution, Quality (Compression), Image to Grayscale",
    navigate: "/image_converter",
    state: { title: "Image Converter, Image Compressor Free" },
    online: false,
  },
  {
    id: 42,
    name: "Watermark Image",
    subtitle:
      "Protect your digital images with custom watermarks. Add text or images to your pics.",
    navigate: "/watermark_image",
    state: { title: "Watermark Images, Protect Pic Free" },
    online: false,
  },
  {
    id: 43,
    name: "Merge Images",
    subtitle:
      "Merge two or more images vertically or horizontally to create a new image, you can choose the thickness and color of the border.",
    navigate: "/merge_images",
    state: { title: "Merge Images, Photo Merger" },
    online: false,
  },
  {
    id: 44,
    name: "Split Image",
    subtitle:
      "Split an image horizontally, vertically or both. You can choose the sizes and/or quantity of the images being generated.",
    navigate: "/split_image",
    state: { title: "Split Image, Image Splitter" },
    online: false,
  },
  {
    id: 45,
    name: "HTML To Image",
    subtitle:
      "Capture web pages, HTML files, or code into clean, readable image screenshots.",
    navigate: "/html_to_image",
    state: { title: "HTML To Image Converter Free" },
    online: true,
  },
  {
    id: 46,
    name: "Repair PDF",
    subtitle: "Analyze and repair corrupted PDF files.",
    navigate: "/repair_pdf",
    state: { title: "Repair PDF Files Free" },
    online: false,
  },
  {
    id: 47,
    name: "Upscale Image",
    subtitle: "Upscale low resolution images to 4K, 2K images.",
    navigate: "/upscale_image",
    state: { title: "AI Image Upscaler & Upscale Image Online" },
    online: true,
  },
];
